/**
 * Import constants
 */
import { GET_DELAYED_DATA, GET_DELAYED_DATA_PENDING, GET_DELAYED_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: {},
	error: null
};

/**
 * Delayed data reducer
 * @param {*} state
 * @param {*} action
 */
export const delayedReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_DELAYED_DATA_PENDING:
			return {
				...state,
				loading: true
			};
		case GET_DELAYED_DATA:
			return {
				...state,
				loading: false,
				data: Object.assign({}, state.data, action.payload),
				error: null
			};
		case GET_DELAYED_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
